// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__pfHc9","modal":"Modal_modal__9eusI","slide-down":"Modal_slide-down__DacCh"};